import {Specification} from "./Specification";

export class ProjectDetails {
    constructor(obj) {
        this.Project_ID = obj.Project_ID;
        this.Partner_ID = obj.Partner_ID;
        this.ProjectCode = obj.ProjectCode;
        this.Branch_ID = obj.Branch_ID;
        this.ProjectName = obj.ProjectName;
        this.SixnotitaSintirisis = obj.SixnotitaSintirisis;
        this.EktHmerSint = obj.EktHmerSint;
        this.LastSint = obj.LastSint;
        this.setSpecifications(obj.Specifications)
    }

    setSpecifications(specifications) {
        if(specifications){
            this.Specifications = specifications.map(s => new Specification(s))
        }else{
            this.Specifications = []
        }
    }
}
